/**
 * プロットジェネレータ用キーワードデータベース
 * インスピレーションを刺激する多様な単語・シチュエーション・概念を収録
 */

export const plotKeywords = [
  // 物体・アイテム (50個)
  '古びた日記', '壊れた時計', '謎の鍵', '古代の地図', '呪われた宝石',
  '魔法の杖', '失われた写真', '血痕のついた手紙', '錆びた剣', '光る石',
  '封印された箱', '割れた鏡', '古いオルゴール', '謎のメモ', '壊れたロボット',
  '古代の書物', '不思議な薬', '魔法のランプ', '呪いの人形', '星の欠片',
  '金の羽根', '銀の弾丸', '水晶玉', '古い指輪', '謎の種子',
  '竜の鱗', '幽霊船', '浮遊する島', '巨大な卵', '生きている絵画',
  '記憶の結晶', '時間を止める懐中時計', '願いを叶える井戸', '魂の入れ物', '賢者の石',
  '運命の糸', '破れた契約書', '最後の花びら', '消えない炎', '凍った涙',
  '歌う剣', '記憶を映す鏡', '未来の新聞', '過去への扉', '平行世界の鍵',
  '死者の書', '生命の水', '永遠の氷', '虹の橋', '星の砂',

  // 感情・心理状態 (40個)
  '復讐心', '罪悪感', '執着', '嫉妬', '後悔',
  '孤独', '絶望', '希望', '愛憎', '裏切り',
  '信頼', '疑心暗鬼', '恐怖', '勇気', '決意',
  '諦め', '執念', '慈悲', '憎悪', '渇望',
  '郷愁', '焦燥感', '安堵', '歓喜', '悲哀',
  '羨望', '劣等感', '優越感', '恍惚', '虚無感',
  '充実感', '解放感', '喪失感', '背徳感', '達成感',
  '挫折感', '期待', '失望', '感動', '畏怖',

  // 状況・シチュエーション (60個)
  '最後の夜', '運命の出会い', '時間制限', '二者択一', '偽りの平和',
  '嵐の前の静けさ', '逃走劇', '潜入作戦', '最終決戦', '裏切りの瞬間',
  '真実の暴露', '仮面舞踏会', '密室殺人', '時間ループ', '記憶喪失',
  '人質交換', '身分偽装', '二重生活', 'タイムリミット', '一発逆転',
  '絶体絶命', '起死回生', '背水の陣', '最後の審判', '運命の分岐点',
  '禁断の恋', '三角関係', '復讐の連鎖', '世代を超えた因縁', '宿命の対決',
  '偶然の再会', '衝撃の告白', '最後の別れ', '奇跡の生還', '突然の訪問者',
  '深夜の呼び出し', '消えた相続人', '二重人格', '入れ替わり', '並行世界',
  '夢の中の現実', '死者からのメッセージ', '未来からの警告', '過去への干渉', '魂の交換',
  '呪いの発動', '封印の解放', '覚醒の時', '終焉の始まり', '新世界の扉',
  '最初で最後のチャンス', '運命の歯車', '因果応報', '天罰', '奇跡の瞬間',
  '絶望からの復活', '希望の光', '闇からの脱出', '真実への階段', '偽りの仮面',

  // 場所・空間 (50個)
  '廃墟', '地下迷宮', '浮遊城', '深海都市', '雲の上の国',
  '鏡の世界', '夢の中', '忘れられた図書館', '禁じられた森', '呪われた屋敷',
  '時が止まった街', '逆さまの塔', '迷いの砂漠', '永遠の迷路', '境界線',
  '隠された部屋', '秘密の地下室', '屋根裏部屋', '古い教会', '廃病院',
  '沈没船', '灯台', '孤島', '断崖絶壁', '深い洞窟',
  '凍った湖', '燃える山', '霧の谷', '星の海', '虚無の空間',
  '異次元の狭間', '時空の裂け目', '記憶の宮殿', '精神世界', '電脳空間',
  '巨大な樹の内部', '生きている迷宮', '浮遊大陸', '海底神殿', '天空城',
  '地底王国', '氷の城', '砂の都', '機械の街', '廃墟と化した東京',
  '最果ての地', '始まりの場所', '約束の地', '楽園', '地獄の門',

  // 職業・役割 (40個)
  '流浪の騎士', '追放された王子', '記憶を失った暗殺者', '最後の魔法使い', '時の番人',
  '夢を操る者', '死神の使い', '運命の予言者', '禁じられた知識の探求者', '魂の収集家',
  '次元を渡る商人', '星読み', '竜使い', '精霊と話す少女', '機械の心を持つ人形',
  '不老不死の賢者', '呪われた吟遊詩人', '記憶を盗む泥棒', '時間を巻き戻す医者', '死者と話す霊媒師',
  '仮面の暗殺者', '影を操る忍者', '心を読む探偵', '未来を変える革命家', '過去を守る歴史家',
  '世界を渡る冒険家', '秘密を知る司書', '運命を紡ぐ織女', '真実を暴く記者', '奇跡を起こす治療師',
  '闇を統べる支配者', '光を導く巫女', '均衡を保つ調停者', '混沌を愛する道化師', '秩序を守る番人',
  '復讐に燃える戦士', '愛に生きる詩人', '知識を求める学者', '力を追求する魔導士', '平和を願う僧侶',

  // 概念・テーマ (40個)
  '輪廻転生', '因果律', '平行世界', '運命vs自由意志', '善悪の彼岸',
  '永遠の命', '失われた記憶', '偽りの現実', '真実の代償', '選ばれし者',
  '予言の成就', '血の宿命', '魂の契約', '禁断の愛', '許されざる罪',
  '贖罪の旅', '復活の奇跡', '最後の希望', '新たな始まり', '終わりなき戦い',
  '光と闇の均衡', '破壊と創造', '混沌と秩序', '生と死の境界', '過去と未来の交差点',
  '現実と幻想', '理性と狂気', '愛と憎しみ', '信頼と裏切り', '勇気と恐怖',
  '希望と絶望', '自由と束縛', '正義と復讐', '真実と嘘', '光と影',
  '始まりと終わり', '創造と破壊', '進化と退化', '統合と分裂', '覚醒と眠り',

  // 行動・出来事 (40個)
  '時を超える', '記憶を取り戻す', '封印を解く', '契約を結ぶ', '魂を売る',
  '運命に抗う', '過去を変える', '未来を見る', '死者を蘇らせる', '世界を救う',
  '真実を暴く', '嘘を見破る', '仮面を外す', '正体を隠す', '姿を変える',
  '次元を越える', '時間を止める', '空間を歪める', '心を読む', '記憶を消す',
  '夢に入り込む', '影と同化する', '光になる', '透明になる', '分身を作る',
  '魂を入れ替える', '呪いをかける', '祝福を与える', '奇跡を起こす', '運命を変える',
  '約束を果たす', '誓いを立てる', '裏切る', '許す', '復讐する',
  '犠牲になる', '生まれ変わる', '覚醒する', '封印される', '解放される',

  // 時間・タイミング (30個)
  '真夜中', '夜明け前', '日没時', '満月の夜', '新月の闇',
  '百年に一度', '千年の時', '一瞬の判断', '永遠の一秒', '時間の終わり',
  '最初の一歩', '最後の機会', '運命の瞬間', '決断の時', '審判の日',
  '約束の刻', '覚醒の朝', '別れの夕暮れ', '再会の春', '終焉の冬',
  '始まりの朝', '終わりの夜', '転機の秋', '希望の夏', '絶望の真冬',
  '奇跡の瞬間', '呪いの時間', '祝福の時', '真実の時', '偽りの時間',

  // 自然現象・超常現象 (40個)
  '流れ星', '皆既日食', 'オーロラ', '彗星の接近', '惑星直列',
  '時空の歪み', '次元の裂け目', '魂の共鳴', '精神融合', '集合意識',
  '赤い月', '黒い太陽', '逆さまの虹', '永遠の嵐', '止まない雨',
  '凍った炎', '燃える氷', '歌う風', '泣く大地', '笑う海',
  '生きている影', '意思を持つ霧', '記憶の雪', '時間の川', '運命の糸',
  '魂の炎', '心の闇', '希望の光', '絶望の淵', '愛の奇跡',
  '憎しみの連鎖', '悲しみの雨', '喜びの虹', '怒りの雷', '恐怖の霧',
  '夢の扉', '現実の檻', '幻想の庭', '真実の鏡', '嘘の仮面',

  // 追加分：物質・道具 (50個)
  '折れた翼', '黒い手袋', '白い仮面', '赤い糸', '青い薔薇',
  '金の鈴', '銀の笛', '錆びた鍵束', '古い懐中電灯', '壊れた望遠鏡',
  '魔法の絨毯', '透明なマント', '光る羽ペン', '封蝋された手紙', '古びた航海日誌',
  '謎の設計図', '失われた楽譜', '禁断の薬瓶', '魂の灯籠', '運命のサイコロ',
  '時を刻む砂時計', '記憶の万華鏡', '真実の天秤', '嘘発見器', '心を映すプリズム',
  '封印の札', '護符の首飾り', '呪いのブレスレット', '祝福の指輪', '契約の羊皮紙',
  '古代の巻物', '予言の石板', '賢者の杖', '愚者の帽子', '道化師の鈴',
  '騎士の紋章', '魔女の大釜', '錬金術師の瓶', '占い師の水晶', '盗賊の短剣',
  '英雄の盾', '勇者の兜', '姫の髪飾り', '王の玉座', '女王の宝冠',
  '破れた旗', '燃える松明', '消えない蝋燭', '歌う風鈴', '泣く人形',

  // 追加分：生物・クリーチャー (40個)
  '三つ目の鴉', '九尾の狐', '双頭の蛇', '黄金の蝶', '銀色の狼',
  '紅い目の猫', '青い鳥', '白い鹿', '黒い馬', '透明な魚',
  '話す樹', '歩く影', '踊る炎', '歌う風', '笑う月',
  '機械仕掛けの鳥', '幽霊犬', '守護天使', '堕天使', '夢魔',
  '人魚', '半人半馬', 'ドラゴンの子', 'フェニックスの雛', 'ユニコーン',
  '巨大蜘蛛', '吸血蝙蝠', '変身する猫', '予言する鳥', '時を止める蝶',
  '記憶を食べる獣', '嘘を見抜く鳥', '真実を語る蛇', '運命を紡ぐ蜘蛛', '魂を導く蝶',
  '光る蛍', '影の住人', '鏡の中の自分', '過去の亡霊', '未来の使者',

  // 追加分：能力・スキル (40個)
  '瞬間移動', '透視能力', '読心術', '予知夢', '念動力',
  '分身の術', '変身能力', '不可視化', '飛行能力', '治癒能力',
  '時間停止', '時間逆行', '次元移動', '重力操作', '元素操作',
  '幻覚生成', '記憶操作', '感情操作', '夢への侵入', '魂の交換',
  '不老不死', '超人的筋力', '超高速移動', '完全記憶', '絶対音感',
  '動物との会話', '植物操作', '天候操作', '確率操作', '因果律操作',
  '物質変換', 'エネルギー吸収', '力の複製', '能力無効化', '絶対防御',
  '精神支配', '暗示', '催眠術', '共感能力', '霊視',

  // 追加分：場所・建築物 (50個)
  '回転する塔', '逆さまの城', '水中の宮殿', '雲の上の神殿', '地底の迷宮',
  '動く迷路', '消える橋', '現れる島', '沈む大陸', '浮遊する庭園',
  '鏡の回廊', 'ガラスの階段', '水晶の洞窟', '氷の宮殿', '炎の神殿',
  '忘却の川', '記憶の泉', '知恵の樹', '生命の泉', '死の谷',
  '始まりの地', '終わりの場所', '中心の塔', '辺境の村', '国境の関所',
  '秘密の抜け道', '隠し部屋', '地下牢', '展望台', '天文台',
  '古い劇場', '廃れた遊園地', '沈黙の図書館', '叫びの洞窟', '囁きの森',
  '巨人の墓', '妖精の輪', '魔女の家', '賢者の塔', '愚者の楽園',
  '英雄の祠', '悪魔の門', '天使の梯子', '神々の座', '精霊の泉',
  '竜の巣', '不死鳥の止まり木', '獣の檻', '鳥籠', '蜘蛛の巣城',

  // 追加分：現象・出来事 (50個)
  '逆流する時間', '繰り返す一日', '消えた記憶', '偽りの記憶', '共有される夢',
  '現実の崩壊', '世界の融合', '次元の衝突', '時空の歪み', '因果の逆転',
  '魂の分離', '精神の融合', '意識の交換', '記憶の移植', '感情の伝染',
  '集団幻覚', '予言の成就', '呪いの発現', '奇跡の顕現', '神の介入',
  '悪魔の契約', '天使の祝福', '精霊の加護', '竜の目覚め', '封印の崩壊',
  '結界の破壊', '門の開放', '橋の崩落', '壁の出現', '道の分岐',
  '選択の時', '決断の瞬間', '覚悟の時', '告白の時', '別離の時',
  '再会の約束', '永遠の誓い', '血の盟約', '魂の契約', '運命の出会い',
  '偶然の一致', '必然の結果', '皮肉な結末', '予想外の展開', '衝撃の真相',
  '隠された事実', '明かされる秘密', '暴かれる嘘', '判明する正体', '覆る常識',

  // 追加分：感覚・感触 (30個)
  '冷たい風', '熱い吐息', '甘い香り', '苦い味', '鋭い痛み',
  '鈍い音', '高い声', '低い唸り', '静かな足音', '大きな爆発',
  '柔らかい感触', '硬い表面', '滑らかな肌', '粗い布地', 'ぬるぬるした液体',
  '眩しい光', '深い闇', '薄暗い影', '鮮やかな色', '褪せた写真',
  '焦げた匂い', '腐った臭い', '花の香り', '潮の香り', '土の匂い',
  '金属の味', '血の味', '涙の塩味', '汗の匂い', '死の気配',

  // 追加分：抽象概念 (40個)
  '存在の意味', '生きる理由', '死ぬ覚悟', '愛の定義', '幸せの形',
  '正義の基準', '悪の本質', '善悪の境界', '真実と嘘', '現実と幻想',
  '理想と現実', '夢と希望', '絶望と再生', '破壊と創造', '始まりと終わり',
  '循環する歴史', '螺旋の運命', '平行線の人生', '交差する運命', '分岐する未来',
  '固定された過去', '変えられる未来', '今この瞬間', '永遠の一瞬', '刹那の永遠',
  '無限の可能性', '有限の時間', '絶対的な力', '相対的な価値', '普遍的な真理',
  '個人の自由', '集団の意志', '社会の規範', '文化の違い', '価値観の衝突',
  '世代間の断絶', '伝統の継承', '革新と保守', '進化と退化', '成長と衰退',

  // 追加分：人間関係・感情 (40個)
  '初恋の相手', '幼馴染', '宿敵', '恩人', '裏切り者',
  '守護者', '破壊者', '創造者', '観察者', '傍観者',
  '共犯者', '目撃者', '追跡者', '逃亡者', '救済者',
  '片思い', '両想い', '三角関係', '四角関係', '複雑な関係',
  '師弟関係', '親子の絆', '兄弟の確執', '姉妹の嫉妬', '家族の秘密',
  '友情の証', '裏切りの代償', '復讐の連鎖', '許しの心', '贖罪の道',
  '依存関係', '共依存', '支配と服従', '対等な関係', '一方的な愛',
  '束縛', '解放', '執着', '無関心', '憧れ',

  // 追加分：時代・文明 (30個)
  '失われた文明', '古代帝国', '未来都市', '原始時代', '中世の王国',
  '産業革命', '情報化社会', '仮想現実時代', '宇宙開拓時代', '終末後の世界',
  '魔法文明', '科学文明', '精神文明', '機械文明', '生物文明',
  '黄金時代', '暗黒時代', '啓蒙時代', '混沌時代', '新時代',
  '戦国時代', '平和な時代', '変革期', '過渡期', '黎明期',
  '最盛期', '衰退期', '復興期', '停滞期', '発展期',

  // 追加分：自然・天体 (40個)
  '二つの太陽', '三つの月', '落ちる星', '昇る惑星', '近づく彗星',
  '銀河の中心', 'ブラックホール', 'ホワイトホール', 'ワームホール', '異次元の穴',
  '極光', '蜃気楼', '幻日', '虹の橋', '天の川',
  '大津波', '大地震', '大噴火', '大洪水', '大干ばつ',
  '永久凍土', '灼熱の砂漠', '密林', '大草原', '大峡谷',
  '浮島', '沈む島', '動く山', '生きている森', '意思を持つ海',
  '結晶の谷', '石化の森', 'ガラスの砂漠', '鉄の山脈', '塩の湖',
  '毒の沼', '癒しの泉', '若返りの水', '老化の風', '死の霧'
]

/**
 * ランダムにキーワードを選択
 * @param count 選択する個数
 * @param seed シード値（オプション）
 * @returns 選択されたキーワードの配列
 */
export function getRandomKeywords(count: number, seed?: number): string[] {
  const rng = seed ? seedRandom(seed) : Math.random
  
  const shuffled = [...plotKeywords].sort(() => rng() - 0.5)
  return shuffled.slice(0, count)
}

/**
 * 特定のインデックスのキーワードを取得
 * @param indices インデックスの配列
 * @returns キーワードの配列
 */
export function getKeywordsByIndices(indices: number[]): string[] {
  return indices.map(i => plotKeywords[i % plotKeywords.length])
}

/**
 * シード値から擬似乱数を生成
 */
function seedRandom(seed: number): () => number {
  let s = seed
  return () => {
    s = (s * 1103515245 + 12345) % 2147483648
    return s / 2147483648
  }
}

// 合計: 700個以上のキーワード
export const KEYWORD_COUNT = plotKeywords.length